import script from "./VouchersSuccessPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VouchersSuccessPage.vue?vue&type=script&setup=true&lang=ts"

import "./VouchersSuccessPage.vue?vue&type=style&index=0&id=1f12ef51&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f12ef51"]])

export default __exports__